import styled from "styled-components/macro";
import {
  Box,
  BoxHeader,
  BoxContent,
  BoxTitle,
  BoxNavRight,
  BoxNavButton,
} from "./Box";
import { Close } from "./Icons";
import Button from "./Button";
import { THEME_COLOR_DARK } from "../vars";
import usePlan from "../hooks/use-plan";
import useLocalStorage from "../hooks/use-local-storage";
import { useHistory } from "react-router";

function UpgradeModal() {
  const history = useHistory();
  const plan = usePlan();
  const [
    hasDismissedUpgradeModal,
    setHasDismissedUpgradeModal,
  ] = useLocalStorage("hasDismissedUpgradeModal", false, window.sessionStorage);

  const show = Number(plan.price === 0) && !hasDismissedUpgradeModal;

  if (!show) return null;

  function hide() {
    setHasDismissedUpgradeModal(true);
  }

  return (
    <Container elevated>
      <BoxHeader stacked white>
        <BoxTitle>Ready to upgrade?</BoxTitle>
        <BoxNavRight>
          <BoxNavButton onClick={() => hide()}>
            <Close />
          </BoxNavButton>
        </BoxNavRight>
      </BoxHeader>
      <BoxContent>
        <p>
          Gain access to additional prewritten campaigns, messages, CRM
          integrations, automations, and more when you upgrade your account.
        </p>
        <Button
          onClick={() => {
            history.push("/app/plan");
          }}
        >
          See Plans
        </Button>
      </BoxContent>
    </Container>
  );
}

const Container = styled(Box)`
  position: absolute;
  bottom: 50px;
  right: 50px;
  width: 100%;
  max-width: 550px;
  z-index: 9999;
  p {
    line-height: 1.4em;
  }
  ${BoxTitle} {
    font-weight: 500;
    font-size: 18px;
    color: ${THEME_COLOR_DARK};
  }
  ${BoxContent} {
    padding-top: 0px;
    flex-direction: row;
    display: flex;
    align-items: center;
    & > :last-child {
      flex-shrink: 0;
      margin-left: 20px;
    }
  }
`;

export default UpgradeModal;
